export { ConfirmProvider } from "material-ui-confirm";
import { ConfirmOptions, useConfirm } from "material-ui-confirm";

export const useConfirmOrAlert = () => {
  const confirm = useConfirm();

  const handleConfirm = async (options: ConfirmOptions) => {
    let res = false;

    const confirmOptions = {
      confirmationText: "OK",
      cancellationText: "キャンセル",
      title: "",
      ...options,
    };

    await confirm(confirmOptions)
      .then(() => {
        res = true;
      })
      .catch(() => {
        res = false;
      });
    return res;
  };

  const handleAlert = async (options: ConfirmOptions) => {
    const alertOptions = {
      confirmationText: "OK",
      title: "",
      cancellationButtonProps: { disabled: true },
      cancellationText: "",
      ...options,
    };

    await confirm(alertOptions);
  };

  return { handleConfirm, handleAlert };
};
